import olExtent from 'ol/extent';

export default function combineExtents(extents) {
	const combinedExtent = olExtent.createEmpty();
	extents.filter(extent => !!extent).forEach(extent => olExtent.extend(combinedExtent, extent));

	return combinedExtent;
}
